import { isGuideSupported } from "@expert/solve-tools";

interface OpenOnCallStartProps {
    disableAutomaticOpen: boolean;
    isCustomerSession: boolean;
    isGuideEnabled: boolean;
    isGuideOpen: boolean;
    isLoadingSimplrSession: boolean;
}
export function shouldOpenOnCallStart({
    disableAutomaticOpen,
    isCustomerSession,
    isGuideEnabled,
    isGuideOpen,
    isLoadingSimplrSession,
}: Readonly<OpenOnCallStartProps>) {
    const isADTGuideAvailable = isGuideSupported("ADT Guide");

    return (
        isGuideEnabled &&
        isADTGuideAvailable &&
        !isGuideOpen &&
        isCustomerSession &&
        !disableAutomaticOpen &&
        !isLoadingSimplrSession
    );
}
